import {useDispatch, useSelector} from 'react-redux';
import {useAdmitRootStyles} from '../admitStyles';
import {useTranslation} from 'react-i18next';
import {mapHospitalList} from '../../../store/reducers/ward';
import {demographicPatient, setDemographicPatient, setMergeQueuePatient} from '../../../store/reducers/patient';
import config from '../../../app/config';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import {hasOneOfPermission, hasPermission, Permissions} from '../../../store/reducers/user';
import moment from 'moment/moment';
import Typography from '@mui/material/Typography';
import React, {useState} from 'react';
import PatientDemographicsBanner from './patientDemographicsBanner';
import clsx from 'clsx';

export const AgyleHeaderButtonsSection = ({
  activeStep,
  setActiveStep,
  steps,
  admit,
  admission,
  checkFields,
  patientIsSelected,
  setClearForm,
  updatePatient,
  cancelPatientUpdate,
  savePatientUpdate,
  backToInitialAdmit,
  isPatientUpdated,
  handleSubmitAdmission,
  patientOnWhiteboard,
  openCreatePatientDialog,
  isBedBookingChosen,
  setSpeedRegFlag,
  fastReg,
  fromScheduler,
  createNewPatient,
  handleConfirmDemographics,
  openTemporaryPatientEdit,
  openBedas,
  openPriorityList,
  openPatientMerge,
  hospital,
  onHospitalChange,
  temporaryPatientRef,
  temporaryPatientAttendanceRef,
  isAddOnlyPatient,
  onlyDemographic,
  validPostCode,
  validTemporaryPostCode,
  isMergedPatientLocked,
}) => {
  const dispatch = useDispatch();
  const classes = useAdmitRootStyles();
  const { t } = useTranslation();

  const hospitalList = useSelector(mapHospitalList);
  const ptFormPriority = useSelector(demographicPatient);

  const [isDisabled, setIsDisabled] = useState(false);

  const haveFastFlag = admit?.tags?.includes("fastRegistry");
  const checkHospital = config?.modules?.map?.customMap
    ? _.isNull(hospital)
    : false;

  const handleSubmit = async () => {
    try {
      setIsDisabled(true);

      await handleSubmitAdmission()
    } catch (err) {

    } finally {
      setIsDisabled(false);
    }
  }

  const renderSearchButtons = () => {
    return (
      <>
        {config.modules?.map?.customMap && activeStep === 0 && (
          <Grid item style={{ minWidth: 208, maxWidth: 250 }}>
            <AgyleDictionaryField
              options={config.modules?.map?.customMapConfig}
              value={hospital}
              noBorder={false}
              label="Hospital"
              disabled={!_.isNil(hospital)}
              onChange={onHospitalChange}
              isOptionEqualToValue={(option, value) =>
                option.hospitalId === value.hospitalId
              }
              getOptionLabel={(option) => option.name}
              name="Hospital"
              error={_.isNull(hospital)}
              style={{ minWidth: 208, maxWidth: 250 }}
            />
          </Grid>
        )}

        {config.modules?.wardCreator?.admitModeEnable && !config.modules?.map?.customMap && activeStep === 0 && (
          // <Grid item xs={6} md={3} style={{ minWidth: 208, maxWidth: 250 }}>
          <Grid item style={{ minWidth: 208, maxWidth: 250 }}>
            <AgyleDictionaryField
              options={hospitalList}
              value={hospital}
              label="Hospital"
              noBorder={false}
              disabled={!_.isNil(hospital)}
              onChange={onHospitalChange}
              isOptionEqualToValue={(option, value) =>
                option.__id === value.__id
              }
              getOptionLabel={(option) => option.description}
              name="Hospital"
              error={_.isNull(hospital)}
            />
          </Grid>
        )}

        {config?.admitPatient?.bedasListEnabled &&
          config?.modules?.bedas?.enabled && ! fromScheduler && (
            <AgyleButton
              onClick={openBedas}
              colour="primary"
              style={{ minWidth: 105 }}
              disabled={checkHospital}
            >
              {t("Follow Up List")}
            </AgyleButton>
          )}

        {config?.admitPatient?.enablePatientMerge && !fromScheduler && (
          <AgyleButton
            colour="primary"
            onClick={openPatientMerge}
            style={{ minWidth: 120 }}
            disabled={
              checkHospital ||
              !dispatch(
                hasOneOfPermission([
                  Permissions.CAN_ACCESS_MERGES_PAGE,
                  Permissions.CAN_ACCESS_ADMIN_PAGE,
                ]),
              )
            }
          >
            {t("Patient Merge")}
          </AgyleButton>
        )}

        {config?.admitPatient?.enablePriorityList && !fromScheduler && (
          <AgyleButton
            colour="primary"
            onClick={openPriorityList}
            style={{ minWidth: 105 }}
            disabled={
              checkHospital ||
              !dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_PRIORTY_LIST))
            }
          >
            {t("Priority List")}
          </AgyleButton>
        )}

        {!fromScheduler && <AgyleButton
          onClick={setSpeedRegFlag}
          variant="contained"
          fullWidth
          disabled={checkHospital || fastReg}
          style={{ minWidth: 208 }}
        >
          {t("+ ADD TEMPORARY PATIENT")}
        </AgyleButton>}

        {config?.admitPatient?.patientCreationEnabled && !fromScheduler && (
          <AgyleButton
            onClick={() => {
              createNewPatient(true);
              dispatch(setMergeQueuePatient(null));
            }}
            fullWidth
            variant="contained"
            disabled={checkHospital}
            style={{ minWidth: 163 }}
          >
            {t("+ ADD NEW PATIENT")}
          </AgyleButton>
        )}

        {!fromScheduler && <AgyleButton
          onClick={() => {
            fastReg ? createNewPatient() : openCreatePatientDialog();
          }}
          variant="contained"
          fullWidth
          disabled={checkHospital}
          style={{ minWidth: 194 }}
        >
          {t("+ ADD NEW ATTENDANCE")}
        </AgyleButton>}
      </>
    );
  };

  const isSaveDisabled = () => {
    if (isPatientUpdated) {
      let invalidTemp = false;
      if (!_.isNil(admit?.postalCodeTemporary)) {
        invalidTemp = !validTemporaryPostCode || !admit?.streetTemporary;
      }
      return !validPostCode || invalidTemp;
    }
    return false;
  };

  const renderDemographicButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexGrow: 1 }}>
      <PatientDemographicsBanner patient={admit} />

      {patientIsSelected &&
        dispatch(hasPermission(Permissions.AGYLE_CAN_CONFIRM_DEMOGRAPHICS)) &&
        haveFastFlag && (
          <AgyleButton onClick={handleConfirmDemographics} variant="contained">
            {t("Confirm Demographics")}
          </AgyleButton>
        )}
      {patientIsSelected && (
        <>
          {isPatientUpdated && (
            <>
              <AgyleButton onClick={backToInitialAdmit} variant="outlined">
                {t("Back to Original Patient Data")}
              </AgyleButton>
              <AgyleButton onClick={cancelPatientUpdate} variant="outlined">
                {t("Cancel Patient Update")}
              </AgyleButton>
            </>
          )}
          <AgyleButton
            onClick={() => {
              if (isPatientUpdated) {
                savePatientUpdate();
              } else {
                updatePatient();
              }
            }}
            variant="contained"
            disabled={isSaveDisabled() || isMergedPatientLocked}
          >
            {t(isPatientUpdated ? "Save" : "Update Patient Data")}
          </AgyleButton>
        </>
      )}

      {!patientIsSelected && (
        <AgyleButton onClick={() => setClearForm(true)} variant="contained">
          {t("Clear Form")}
        </AgyleButton>
      )}

      {!onlyDemographic && (
        <AgyleButton
          variant="contained"
          onClick={() => setActiveStep((prevState) => prevState + 1)}
          disabled={!checkFields() || isMergedPatientLocked}
        >
          {t(
            isBedBookingChosen
              ? "Bed Booking"
              : isAddOnlyPatient
                ? "Summary"
                : "Attendance Details",
          )}
        </AgyleButton>
      )}
    </div>
  );

  const checkAdmission = () => {
    const isArrivedByAmbulance =
      admission.modeOfArrival &&
      (admission.modeOfArrival?.group === "ambulance" ||
        admission.modeOfArrival?.ambulance);
    const patientAge = moment().diff(moment(admit.dob), "years");

    if (patientAge < 18 && !admission.cpIs) {
      return true;
    }

    if (
      (admission.flag111 && !admission.flag111Timestamp) ||
      (isArrivedByAmbulance &&
        (!admission.careContactIdentifier ||
          !admission.conveyingAmbulanceOrgId ||
          !admission.ambulanceIncidentNumber)) ||
      !admission?.attendanceCategory ||
      !admission.modeOfArrival
    )
      return true;

    return false;
  };

  const renderBedBookingButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexBasis: "content" }}>
      <PatientDemographicsBanner patient={admit} />

      <AgyleButton
        variant="contained"
        onClick={() => {
          setActiveStep((prevStep) => prevStep + 1);
        }}
      >
        {t("Summary")}
      </AgyleButton>
    </div>
  );

  const renderAdmissionButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexBasis: "content" }}>
      <PatientDemographicsBanner patient={admit} />

      <AgyleButton
        variant="contained"
        onClick={() => {
          setActiveStep((prevState) => prevState + 1);
        }}
        disabled={checkAdmission()}
      >
        {t("Proceed to Summary")}
      </AgyleButton>
    </div>
  );

  const renderSummaryButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexBasis: "content" }}>
      <PatientDemographicsBanner patient={admit} />

      <AgyleButton
        variant="contained"
        onClick={handleSubmit}
        disabled={isPatientUpdated || isDisabled}
      >
        {patientOnWhiteboard
          ? t("Update Patient Data")
          : isBedBookingChosen
            ? t("Add to Bed Booking")
            : isAddOnlyPatient
              ? t("Create New Patient")
              : t(
                  `${temporaryPatientAttendanceRef.current ? "Update" : "Create New"} Attendance`,
                )}
      </AgyleButton>
    </div>
  );

  const renderStepButtons = () => {
    // eslint-disable-next-line default-case
    switch (activeStep) {
      case 0:
        return renderSearchButtons();
      case 1:
        return renderDemographicButtons();
      case 2:
        if (isAddOnlyPatient) {
          return renderSummaryButtons();
        } else if (isBedBookingChosen) {
          return renderBedBookingButtons();
        } else {
          return renderAdmissionButtons();
        }
      case 3:
        return renderSummaryButtons();
    }
  };

  const handleBack = () => {
    const back = activeStep - 1;
    setActiveStep(back);
    if (ptFormPriority && back === 0) dispatch(setDemographicPatient(null));
  };

  return (
    <Grid
      gap={2}
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{ p: 1, flexWrap: "nowrap" }}
      className={clsx(classes.searchButtons, 'scroll-normal-white')}
    >
      <Grid
        container
        item
        style={{ alignItems: "center", flexBasis: "fit-content" }}
      >
        <Typography
          variant="h6"
          component="div"
          className={classes.headerText}
          style={{ whiteSpace: "nowrap" }}
        >
          {isAddOnlyPatient
            ? t("Create New Patient")
            : t("Create New Attendance")}
        </Typography>
      </Grid>

      <Grid
        item
        container
        xs={12}
        gap={0.75}
        py={1}
        alignItems="center"
        justifyContent="flex-end"
        className='scroll-normal-white'
      >
        {renderStepButtons()}
      </Grid>
    </Grid>
  );
};
